export const AuthEndpoints = {
  WEB_KEY: "/web/key",
  COOKIE_SESSION: "/web/cookie",
  RELATIONSHIP: "/relationship/user",
  OTP: "/user/otp/v2",
  LIBRARY_ID: "/content/me/personal-library-id",
  LOGOUT: "/web/logout",

  // Cần tham số nên là hàm thay vì chuỗi + string-replace: gõ sai tên biến
  // hoặc quên truyền sẽ báo lỗi TypeScript ngay, không phải chờ chạy thật.
  profile: (id: number | string) => `/user/profile/${id}`,
} as const;
